import {
  AlternativeTransactionCertificateDetails,
  ATBuyerSellerDetails,
  ATProductInfoDetails,
  ATRawMaterialInfo,
} from "./atc-org";

export const initATCertificateDetails: AlternativeTransactionCertificateDetails = {
  uploadType: "",
  transactionCertificateNumber: "",
  tcUploadCb:"",
  dateOfIssue: "",
  tcStandard: [],
  tcVersionNumber: "",
  cbLicensingCode: "",
  uploadedFile: null,
  submissionDate: "", // actual File the user might pick
  
};

export const initATBuyerSellerDetails: ATBuyerSellerDetails = {
  sellerTeId: "",
  sellerAddress: "",
  sellerName: "",
  sellerCbLicensingCode: "",
  sellerState: "",
  sellerCountry: "",
  sellerPostalCode: "",
  sellerTown: "",
  buyerTeId: "",
  buyerAddress: "",
  buyerName: "",
  buyerScNumber: "",
  buyerState: "",
  buyerCountry: "",
  buyerPostalCode: "",
  buyerTown: "",
  sellerHasTeid: "Yes", // new default
};

export const initATProductInfoDetails: ATProductInfoDetails = {
  productNumber: "",
  productCategory: "",
  productDetail: "",
  netShippingWeight: "",
  supplementaryWeight: "",
};

export const initATRawMaterialInfo: ATRawMaterialInfo = {
  associatedProductNumber: "",
  rawMaterialCode: "",
  rawMaterialComposition: "",
  countryArea: "",
  stateProvince: "",
  rawMaterialWeight: "",
};
